export default {
  spanish: 'Español',
  english: 'Inglés',
  catalan: 'Catalán'
}

export const en = {
  spanish: 'Spanish',
  english: 'English',
  catalan: 'Catalan'
}

export const ca = {
  spanish: 'Espanyol',
  english: 'Anglès',
  catalan: 'Català'
}
